import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { TooltipWrapper } from 'src/components/performance-report/performance-returns-details';
import { CopyAccountNumberButton } from 'src/components/shared/copy-account-number-button';
import { padBulletsToMaskedAccountNumber } from 'src/utils/account';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

export default function PortfolioAndAccountItemDescriptionRow({
  icon,
  title,
  subtitle,
  customNote,
  mask,
  accountNumber,
}: {
  readonly icon: React.ReactElement;
  readonly title: string | null | undefined;
  readonly subtitle: string | null;
  readonly customNote: string | null;
  readonly mask: string | null;
  readonly accountNumber?: string | null;
}) {
  const isSmallScreen = useIsSmallScreen();
  const renderTitle = () => {
    return (
      <Text variant={isSmallScreen ? 'body-sm' : 'body'} color="dark" className="font-bold">
        {title}
      </Text>
    );
  };

  return (
    <div className="flex items-center">
      <div className={cn('flex flex-row items-end', isSmallScreen ? 'pr-2' : 'pr-4')}>{icon}</div>
      <div className="flex flex-col gap-0">
        {customNote !== null ? (
          <TooltipWrapper title={customNote} placement="bottom">
            {renderTitle()}
          </TooltipWrapper>
        ) : (
          <>{renderTitle()}</>
        )}

        <div className="flex flex-row gap-1 items-center">
          <Text color="secondary" variant={isSmallScreen ? 'caption' : 'body-sm'}>
            {subtitle?.replaceAll('•', '-')}
            {mask ? ` - ${padBulletsToMaskedAccountNumber(mask)}` : ''}
          </Text>
          <CopyAccountNumberButton accountNumber={accountNumber} />
        </div>
      </div>
    </div>
  );
}
